import { Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { localLogoutUser } from '@/api/services/user';
import { getAccessToken, serverLogoutUser } from '@/stores/auth/services';
import ConfirmModal from '../SharedComponents/ConfirmModal/ConfirmModal';
import { Modal } from '@/components/ui/therapist/Modal';
import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';
import { isPatientApp } from '@/config/constants';

export function DemoModal({
  logoutFromDemo,
  setLogoutFromDemo,
  showDemoPopUp,
  setShowDemoPopUp,
  demoTimerCounter,
  setDemoCounterTimer,
}) {
  const { navigate } = useNavigation();

  const demoWebLogout = () => {
    if (Platform.OS === 'web') {
      const url = new URL(window.location.href);
      url.searchParams.delete('demoStarten');
      window.history.replaceState(null, '', url.toString());
    }
  };

  const confirmAction = async () => {
    demoWebLogout();
    clearTimeout(demoTimerCounter);
    setLogoutFromDemo(false);
    setShowDemoPopUp(false);
    await serverLogoutUser({ jwt: await getAccessToken() });
    await localLogoutUser();
    navigate('SignUpController');
  };

  const cancelAction = async () => {
    if (logoutFromDemo) {
      try {
        demoWebLogout();
        clearTimeout(demoTimerCounter);
        setLogoutFromDemo(false);
        setShowDemoPopUp(false);
        await serverLogoutUser({ jwt: await getAccessToken() });
        await localLogoutUser();
        navigate('Login');
      } catch (_error) {
        await localLogoutUser();
      }
    } else {
      setShowDemoPopUp(false);
      setDemoCounterTimer(
        setTimeout(() => {
          setShowDemoPopUp(true);
        }, 300000),
      );
    }
  };

  return (
    <>
      {isPatientApp ? (
        <ConfirmModal
          verticalAlignButtons={true}
          isVisible={showDemoPopUp}
          contentText="Gefällt Ihnen neolexon? Dann testen Sie unsere App 14 Tage kostenlos mit individuell für Sie eingestellten Wörtern und Sätzen!"
          headerText="Danke für das Ausprobieren der Demo!"
          confirmText="Jetzt zur Testphase anmelden"
          cancelText={logoutFromDemo ? 'Demo beenden' : 'weiter testen'}
          confirmAction={confirmAction}
          cancelAction={cancelAction}
        />
      ) : (
        <Modal
          isVisible={showDemoPopUp}
          cancelActionButton={
            <Button
              label={logoutFromDemo ? 'Demo beenden' : 'weiter testen'}
              look="secondary"
              onPress={cancelAction}
            />
          }
          confirmActionButton={
            <Button
              label="Jetzt zur Testphase anmelden"
              look="danger"
              onPress={confirmAction}
            />
          }
          onClose={() => setShowDemoPopUp(false)}
          title="Danke für das Ausprobieren der Demo!"
        >
          <Text style={{ fontSize: 20 }}>
            Gefällt Ihnen neolexon? Dann testen Sie unsere App 14 Tage kostenlos
            mit individuell für Sie eingestellten Wörtern und Sätzen!
          </Text>
        </Modal>
      )}
    </>
  );
}
